import parseDate from 'date-fns/parse'

/**
 * @typedef {Object} ReleaseData
 * @property {(number|string)} version - X.X will be numbers, X.X.X will be strings (due to YML)
 * @property {number}          [build] - optional build number for the release binary
 * @property {string}          release-date - release date as DD-MM-YYYY
 * @property {string}          requirements - human-readable as "{OS name} {OS version name} ({ OS version number}) or newer"
 * @property {string}          guid - unique release identifier
 * @property {string}          url
 */

/**
 * Get an array with releases, reverse-chron
 * @returns {Promise<?ReleaseData[]>}
 */
async function macReleases() {
  const response = await fetch('/api/releases/mac.json')
  if (!response.ok) throw new Error('Failed to request /api/releases/mac.json')

  /** @type {ReleaseData[]} */
  const releases = await response.json()
  // Transform data for JS usage
  releases.forEach((release) => {
    // release versions might be numbers, make all strings
    release.version = release.version.toString()
    // transform to Date
    release['release-date'] = parseDate(release['release-date'], 'yyyy-MM-dd', new Date())
  })
  return releases
}

/**
 * Get the most recent Mac release as of a date
 * @param {(number|Date)} timestampOrDate
 * @returns {Promise<?ReleaseData>}
 */
async function latestMacReleaseOnDate(timestampOrDate) {
  const expirationDate = typeof timestampOrDate === 'number' ? new Date(timestampOrDate * 1000) : timestampOrDate
  const releases = await macReleases()

  let latestRelease = null
  releases.forEach((release) => {
    if (release['release-date'] > expirationDate) return

    if (!latestRelease || release['release-date'] > latestRelease['release-date']) {
      latestRelease = release
    }
  })
  return latestRelease
}

export { macReleases, latestMacReleaseOnDate }
